import React, { useEffect, useState, useContext } from "react";
import "../styles/projectInformation.css";
import { Link, useParams, useNavigate } from "react-router-dom";
import { eachDayOfInterval, isWeekend, parseISO } from 'date-fns';
import Table from "../components/ProjectInformation/Table";
import ProjectTitle from "../components/ProjectDetails/ProjectTitle";
import LoadingIcon from "../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { AppContext } from "../contexts/AppContext";
import { UrlContext } from "../contexts/UrlContext";
import { UserContext } from "../contexts/UserContext";
import EmailComposer from "../pages/EmailComposer";

// import MaterialTable from 'material-table'

export default function ProjectInformation() {
  const id = useParams().proj_id;
  // console.log(useParams().proj_id)
  const exp_id = useParams().exp_id;
  const extension = useParams().extension;
  // let contracting = useParams().contracting;

  useEffect(() => {
    if (contracting === "0") {
      document.title = "Project Information";
    } else {
      document.title = "Contract Details";
    }
  }, []);

  const [contracting, setContracting] = useState(useParams().contracting);
  const [createContracts, setCreateContracts] = useState(true);
  // console.log(useParams().exp_id)
  const { API_URL } = useContext(UrlContext);
  const { projects, setProjects, projectWithFilter } = useContext(AppContext);
  const { userData } = useContext(UserContext);
  const [FinalUpdateLoading, setFinalUpdateLoading] = useState(false);
  const [gettingExRates, setGettingExRates] = useState(false);

  const [data, setData] = useState([]);
  const [name, setName] = useState([]);
  const [expertIds, setExpertIds] = useState([]);
  const [consulforeignValue, setconsulForeignValue] = useState([]);
  const [EPHforeignValue, setEPHForeignValue] = useState([]);
  const [consuleuroValue, setconsulEuroValue] = useState("");
  const [noConFound, setNoConFound] = useState(false);
  const [epheuroValue, setephEuroValue] = useState("");
  const [consulexchangeInfo, setconsulExchangeInfo] = useState("");
  const [EPHexchangeInfo, setEPHExchangeInfo] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [consultantRate, setConsultantRate] = useState("");
  const [ephRate, setEphRate] = useState("");
  const [utilizationIntensity, setUtilizationIntensity] = useState("");
  const [daysUsed, setDaysUsed] = useState("");
  const [composeEmail, setComposeEmail] = useState(false);
  const [composeFollowUpEmail, setComposeFollowUpEmail] = useState(false);
  const [emailDetails, setEmailDetails] = useState("");
  const [followUpEmailDetails, setFollowUpEmailDetails] = useState("");
  const [followUpExists, setFollowUpExists] = useState(false);
  const [loadingPopup, setLoadingPopup] = useState(false);
  const [projectType, setProjectType] = useState("");
  const [callDuration, setCallDuration] = useState(0);
  const [suggestedConPay, setSuggestedConPay] = useState(0);
  const [suggestedEPHPay, setSuggestedEPHPay] = useState(0);
  const [currencyCon, setCurrencyCon] = useState("");
  const [currencyEPH, setCurrencyEPH] = useState("");
  const [rateCon, setRateCon] = useState(0);
  const [rateEPH, setRateEPH] = useState(0);
  const [disableConRate, setDisableConRate] = useState(false);
  const [disableConCurrency, setDisableConCurrency] = useState(false);
  const [disableEPHRate, setDisableEPHRate] = useState(false);
  const [disableEPHCurrency, setDisableEPHCurrency] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const navigate = useNavigate();

  const navigateToProjectOverview = () => {
    navigate("/app/ProjectsOverview");
  };

  const navigateToProjectDetail = () => {
    navigate("/app/ProjectDetails/" + id);
  };

  const selectData = async (profData) => {
    const newExpertIds = [...expertIds];
    console.log(
      "userdata",
      userData,
      profData.status,
      newExpertIds,
      contracting
    );
    profData["utilizationIntensity"] = utilizationIntensity;
    if (daysUsed) {
      profData["daysUsed"] = daysUsed;
    }
    profData["projectID"] = id;
    // if(profData.status === "Contracting"){
    //   const response = await getContractingRates(profData);
    //   if (response.status === "done") {
    //     console.log("done", response.results);
    //     newExpertIds.push(response.results);
    //     setExpertIds(newExpertIds);
    //     const idName = "ephEuroInfo" + profData["id"];
    //     const elem = document.getElementById(idName);
    //     console.log("element", elem);
    //     if (elem) {
    //       elem.textContent = response.results["forEPHInfo"];
    //     }
    //     if (!gettingExRates) {
    //       setTimeout(() => {
    //         console.log("waiting 2 sec");
    //         const idName = "ephEuroInfo" + profData["id"];
    //         const elem = document.getElementById(idName);
    //         console.log("element", elem);
    //         if (elem) {
    //           elem.textContent = response.results["forEPHInfo"];
    //         }
    //       }, 1000);
    //     }
    //   } else {
    //     newExpertIds.push(profData);
    //     setExpertIds(newExpertIds);
    //   }
    // }

    // if (userData.roles.includes("Tester")) {
    if (profData.status !== "Contracting") {
      const response = await getRateInfo(profData);
      console.log("results from calling", response);
      if (response.status === "done") {
        console.log("done", response.results);
        newExpertIds.push(response.results);
        setExpertIds(newExpertIds);
        const idName = "ephEuroInfo" + profData["id"];
        const elem = document.getElementById(idName);
        console.log("element", elem);
        if (elem) {
          elem.textContent = response.results["forEPHInfo"];
        }
        if (!gettingExRates) {
          setTimeout(() => {
            console.log("waiting 2 sec");
            const idName = "ephEuroInfo" + profData["id"];
            const elem = document.getElementById(idName);
            console.log("element", elem);
            if (elem) {
              elem.textContent = response.results["forEPHInfo"];
            }
          }, 1000);
        }
      } else {
        newExpertIds.push(profData);
        setExpertIds(newExpertIds);
      }
    } else if (profData.status === "Contracting") {
      const response = await getContractingRates(profData);
      if (response.status === "done") {
        console.log("done", response.results);
        newExpertIds.push(response.results);
        setExpertIds(newExpertIds);
        const idName = "ephEuroInfo" + profData["id"];
        const elem = document.getElementById(idName);
        console.log("element", elem);
        if (elem) {
          elem.textContent = response.results["forEPHInfo"];
        }
        if (!gettingExRates) {
          setTimeout(() => {
            console.log("waiting 2 sec");
            const idName = "ephEuroInfo" + profData["id"];
            const elem = document.getElementById(idName);
            console.log("element", elem);
            if (elem) {
              elem.textContent = response.results["forEPHInfo"];
            }
          }, 1000);
        }
      } else {
        newExpertIds.push(profData);
        setExpertIds(newExpertIds);
      }
    }
    // } else {
    //   newExpertIds.push(profData);
    //   setExpertIds(newExpertIds);
    // }
  };

  const getContractingRates = async (profData) => {
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    // const url = `${API_URL}api_project_information_exp_status/${id}/${exp_id}`;
    const url = `${API_URL}get-contracting-rates`;
    try {
      const resp = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({ profData: profData, projectID: id }),
      });

      const data = await resp.json();

      if (data.status === "success") {
        console.log("rates: ", data.ratesInfo);
        const rateInfo = data.ratesInfo;
        if (rateInfo.consul_currency == "EUR") {
          profData["consultantRate"] = rateInfo.consul_rate.toString();
          profData["currencyCon"] = "EUR";
          profData["forconsuleRate"] = "";
          setConsultantRate(rateInfo.consul_rate.toString());
        } else {
          profData["consultantRate"] = "";
          profData["currencyCon"] = rateInfo.consul_currency;
          profData["forconsuleRate"] = rateInfo.consul_rate.toString();
          setConsultantRate(rateInfo.consul_rate.toString());
          profData["consultantRate"] = rateInfo.full_infoConsul.value;
          const resInfo =
                        "Exchange rate: " +
                        rateInfo.full_infoConsul.rate +
                        " as of " +
                        rateInfo.full_infoConsul.date +
                        ", Value in Euros: " +
                        rateInfo.full_infoConsul.value;
          profData["forConsulInfo"] = resInfo;
          const idName = "consulEuroInfo" + profData["id"];
          const elem = document.getElementById(idName);
          if (elem) {
            elem.textContent = resInfo;
          }
        }

        if (rateInfo.eph_currency === "EUR") {
          profData["ephEuroRate"] = rateInfo.eph_rate.toString();
          profData["currencyEPH"] = rateInfo.eph_currency;
          profData["forephRate"] = "";
          setEphRate(rateInfo.eph_rate.toString());
        } else {
          profData["ephEuroRate"] = "";
          profData["currencyEPH"] = rateInfo.eph_currency;
          profData["forephRate"] = rateInfo.eph_rate.toString();
          setEphRate(rateInfo.eph_rate.toString());
          profData["ephEuroRate"] = rateInfo.full_infoEPH.value;
          const resInfo =
                        "Exchange rate: " +
                        rateInfo.full_infoEPH.rate +
                        " as of " +
                        rateInfo.full_infoEPH.date +
                        ", Value in Euros: " +
                        rateInfo.full_infoEPH.value;
          profData["forEPHInfo"] = resInfo;
          const idName = "ephEuroInfo" + profData["id"];
          const elem = document.getElementById(idName);
          if (elem) {
            elem.textContent = resInfo;
          }
        }
        console.log("dates", rateInfo.proj_start, rateInfo.proj_end);
        profData["startDate"] = rateInfo.proj_start;
        profData["endDate"] = rateInfo.proj_end;
        profData["utilizationIntensity"] = rateInfo.utilizationIntensity;
        profData["daysUsed"] = rateInfo.total_days;
        setDaysUsed(rateInfo.total_days);
        setUtilizationIntensity(rateInfo.utilizationIntensity);
        // profData["currencyEPH"] = rateInfo.ephRateCurrency;
        // profData["forephRate"] = rateInfo.eph_rate;

        // const info = await handleForeignCurrency(
        //     profData["currencyEPH"],
        //     profData["forephRate"],
        //     profData,
        //     "EPH"
        // );

        // profData["ephEuroRate"] = info.value;
        // const resInfo =
        //     "Exchange rate: " +
        //     info.rate +
        //     " as of " +
        //     info.date +
        //     ", Value in Euros: " +
        //     info.value;
        // profData["forEPHInfo"] = resInfo;

        // const idName = "ephEuroInfo" + profData["id"];
        // const elem = document.getElementById(idName);
        // if (elem) {
        //     elem.textContent = resInfo;
        // }
        // }

        console.log(profData);
        const daysArray = eachDayOfInterval({
                          start: parseISO(profData["startDate"]),
                          end: parseISO(profData["endDate"]),
                        });
                    
        const workingDays = daysArray.filter(day => !isWeekend(day));
        profData['totalWorkingDays'] = workingDays.length;
        return { status: "done", results: profData };
      } else {
        return { status: "error" };
      }
    } catch (err) {
      console.log(err);
      return { status: "error" };
    }

    // const resp = await fetch(url, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //     "x-access-token": token,
    //   },
    //   body: JSON.stringify({'profData': profData, 'projectID': id}),
    // })
    //   .then((res) => res.json())
    //   .then((data) => {
    //     // setName(data.project);
    //     if (data.status === "success") {
    //       console.log('rates: ',data.ratesInfo)
    //       const rateInfo = data.ratesInfo
    //       if(rateInfo.ephRateCurrency === "EUR"){
    //         profData["ephEuroRate"] = rateInfo.eph_rate;
    //         profData["currencyEPH"] = "EUR";
    //         profData["forephRate"] = "";
    //       } else {
    //         profData["currencyEPH"] = rateInfo.ephRateCurrency
    //         profData["forephRate"] = rateInfo.eph_rate;
    //         const info = await handleForeignCurrency(
    //                     profData["currencyEPH"],
    //                     profData["forephRate"],
    //                     profData,
    //                     "EPH"
    //                   );
    //         profData["ephEuroRate"] = info.value;
    //         const resInfo =
    //                     "Exchange rate: " +
    //                     info.rate +
    //                     " as of " +
    //                     info.date +
    //                     ", Value in Euros: " +
    //                     info.value;
    //         profData["forEPHInfo"] = resInfo;
    //         const idName = "ephEuroInfo" + profData["id"];
    //         const elem = document.getElementById(idName);
    //         if (elem) {
    //                     elem.textContent = resInfo;
    //         }
    //       }
    //       console.log(profData)
    //       return {'status':"done", 'results': profData}
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    //   return resp
  };

  const getRateInfo = async (profData) => {
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    // const url = `${API_URL}api_project_information_exp_status/${id}/${exp_id}`;
    const url = `${API_URL}get-profile-rates`;
    try {
      const resp = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({ profData: profData, projectID: id }),
      });

      const data = await resp.json();

      if (data.status === "success") {
        console.log("rates: ", data.ratesInfo);
        const rateInfo = data.ratesInfo;
        if (rateInfo.consul_currency === "EUR") {
          profData["consultantRate"] = rateInfo.consul_rate;
          profData["currencyCon"] = rateInfo.consul_currency;
          profData["forconsuleRate"] = "";
          setCurrencyCon(rateInfo.consul_currency);
          setConsultantRate(rateInfo.consul_rate);
        } else {
          profData["forconsuleRate"] = rateInfo.consul_rate;
          profData["currencyCon"] = rateInfo.consul_currency;
          profData["consultantRate"] = "";
          setCurrencyCon(rateInfo.consul_currency);
          setConsultantRate(rateInfo.consul_rate);
          profData["consultantRate"] = rateInfo.full_infoConsul.value;
          const resInfo =
                        "Exchange rate: " +
                        rateInfo.full_infoConsul.rate +
                        " as of " +
                        rateInfo.full_infoConsul.date +
                        ", Value in Euros: " +
                        rateInfo.full_infoConsul.value;
          profData["forConsulInfo"] = resInfo;
          const idName = "consulEuroInfo" + profData["id"];
          const elem = document.getElementById(idName);
          if (elem) {
            elem.textContent = resInfo;
          }
        }

        if (rateInfo.ephRateCurrency === "EUR") {
          profData["ephEuroRate"] = rateInfo.eph_rate;
          profData["currencyEPH"] = rateInfo.ephRateCurrency;
          profData["forephRate"] = "";
          setEphRate(rateInfo.eph_rate);
          setCurrencyEPH(rateInfo.ephRateCurrency);
        } else {
          profData["ephEuroRate"] = "";
          profData["currencyEPH"] = rateInfo.ephRateCurrency;
          profData["forephRate"] = rateInfo.eph_rate;
          setEphRate(rateInfo.eph_rate);
          setCurrencyEPH(rateInfo.ephRateCurrency);
          profData["ephEuroRate"] = rateInfo.full_infoEPH.value;
          const resInfo =
                        "Exchange rate: " +
                        rateInfo.full_infoEPH.rate +
                        " as of " +
                        rateInfo.full_infoEPH.date +
                        ", Value in Euros: " +
                        rateInfo.full_infoEPH.value;
          profData["forEPHInfo"] = resInfo;
          const idName = "ephEuroInfo" + profData["id"];
          const elem = document.getElementById(idName);
          if (elem) {
            elem.textContent = resInfo;
          }
        }
        //     profData["currencyEPH"] = rateInfo.ephRateCurrency;
        //     profData["forephRate"] = rateInfo.eph_rate;

        //     const info = await handleForeignCurrency(
        //         profData["currencyEPH"],
        //         profData["forephRate"],
        //         profData,
        //         "EPH"
        //     );

        //     profData["ephEuroRate"] = info.value;
        //     const resInfo =
        //         "Exchange rate: " +
        //         info.rate +
        //         " as of " +
        //         info.date +
        //         ", Value in Euros: " +
        //         info.value;
        //     profData["forEPHInfo"] = resInfo;

        //     const idName = "ephEuroInfo" + profData["id"];
        //     const elem = document.getElementById(idName);
        //     if (elem) {
        //         elem.textContent = resInfo;
        //     }
        // }

        if('totalDays' in rateInfo){
          profData["daysUsed"] = rateInfo.totalDays;
          setDaysUsed(rateInfo.totalDays)
        }

        if('startDate' in rateInfo){
          setStartDate(rateInfo.startDate);
          profData["startDate"] = rateInfo.startDate;
        }

        if('endDate' in rateInfo){
          setEndDate(rateInfo.endDate);
          profData["endDate"] = rateInfo.endDate;
        }

        if('utilizationIntensity' in rateInfo){
          profData["utilizationIntensity"] = rateInfo.utilizationIntensity;
          setUtilizationIntensity(rateInfo.utilizationIntensity);
        }
        

        console.log(profData);
        return { status: "done", results: profData };
      } else {
        return { status: "error" };
      }
    } catch (err) {
      console.log(err);
      return { status: "error" };
    }

    // const resp = await fetch(url, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //     "x-access-token": token,
    //   },
    //   body: JSON.stringify({'profData': profData, 'projectID': id}),
    // })
    //   .then((res) => res.json())
    //   .then((data) => {
    //     // setName(data.project);
    //     if (data.status === "success") {
    //       console.log('rates: ',data.ratesInfo)
    //       const rateInfo = data.ratesInfo
    //       if(rateInfo.ephRateCurrency === "EUR"){
    //         profData["ephEuroRate"] = rateInfo.eph_rate;
    //         profData["currencyEPH"] = "EUR";
    //         profData["forephRate"] = "";
    //       } else {
    //         profData["currencyEPH"] = rateInfo.ephRateCurrency
    //         profData["forephRate"] = rateInfo.eph_rate;
    //         const info = await handleForeignCurrency(
    //                     profData["currencyEPH"],
    //                     profData["forephRate"],
    //                     profData,
    //                     "EPH"
    //                   );
    //         profData["ephEuroRate"] = info.value;
    //         const resInfo =
    //                     "Exchange rate: " +
    //                     info.rate +
    //                     " as of " +
    //                     info.date +
    //                     ", Value in Euros: " +
    //                     info.value;
    //         profData["forEPHInfo"] = resInfo;
    //         const idName = "ephEuroInfo" + profData["id"];
    //         const elem = document.getElementById(idName);
    //         if (elem) {
    //                     elem.textContent = resInfo;
    //         }
    //       }
    //       console.log(profData)
    //       return {'status':"done", 'results': profData}
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    //   return resp
  };

  const unselectData = (profData) => {
    const newExpertIds = expertIds.filter((expertId) => expertId !== profData);
    setExpertIds(newExpertIds);
  };

  const validateForm = () => {
    const blankDates = expertIds.some(
      (experts) => experts.startDate === "" || experts.endDate === ""
    );
    const missingDate = expertIds.some(
      (experts) =>
        !experts.hasOwnProperty("startDate") ||
        !experts.hasOwnProperty("endDate")
    );

    if (blankDates || missingDate) {
      Swal.fire({
        icon: "warning",
        text: "Check dates before submit",
        timer: 2000,
        timerProgressBar: true,
      });
      return false;
    }

    const negRates = expertIds.some(
      (experts) =>
        parseFloat(experts.consultantRate) < 0 ||
        parseFloat(experts.ephEuroRate) < 0 ||
        !/^$|^[0-9]+(\.[0-9]+)?$/.test(experts.consultantRate) ||
        !/^$|^[0-9]+(\.[0-9]+)?$/.test(experts.ephEuroRate) ||
        !/^$|^[0-9]+(\.[0-9]+)?$/.test(experts.forconsuleRate) ||
        !/^$|^[0-9]+(\.[0-9]+)?$/.test(experts.forephRate)
    );
    const missingRates = expertIds.some(
      (experts) =>
        !experts.hasOwnProperty("consultantRate") ||
        !experts.hasOwnProperty("ephEuroRate")
    );

    if (negRates || missingRates) {
      Swal.fire({
        icon: "warning",
        text: "Rates should be a valid number",
        timer: 2000,
        timerProgressBar: true,
      });
      return false;
    }

    const hasInvalidConRates = expertIds.some(
      (item) => item.currencyCon !== "EUR" && !item.consultantRate
    );

    if (hasInvalidConRates) {
      Swal.fire({
        icon: "warning",
        text: "Consultant rate needs to be converted!",
        timer: 2000,
        timerProgressBar: true,
      });
      return false;
    }

    const hasInvalidEPHRates = expertIds.some(
      (item) => item.currencyEPH !== "EUR" && !item.ephEuroRate
    );

    if (hasInvalidEPHRates) {
      Swal.fire({
        icon: "warning",
        text: "EPH rate needs to be converted!",
        timer: 2000,
        timerProgressBar: true,
      });
      return false;
    }
    const invalidIntensity = expertIds.some(
      (experts) =>
        parseFloat(experts.utilizationIntensity) <= 1 ||
        !/^\d+(\.\d+)?$/.test(experts.utilizationIntensity)
    );
    const missingIntensity = expertIds.some(
      (experts) => !experts.hasOwnProperty("utilizationIntensity")
    );

    if (invalidIntensity || missingIntensity) {
      Swal.fire({
        icon: "warning",
        text: "Invalid intensity!",
        timer: 2000,
        timerProgressBar: true,
      });
      return false;
    }

    return true;
  };

  const callConsulAPI = async (forValue) => {
    // console.log(foreignValue)
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    const url = `${API_URL}get-exchange-values/${JSON.stringify(forValue)}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      });
      const data = response.json();
      return data;
    } catch (error) {
      throw new Error("Error fetching conversion API: ", error);
    }
  };

  useEffect(() => {
    // callConsulAPI();
    if (contracting === "0") {
      setCreateContracts(false);
    }
  }, []);

  useEffect(() => {
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    var url = "";
    if (exp_id) {
      url = `${API_URL}api_project_information_exp_status/${id}/${exp_id}/${contracting}`;
    } else if (extension) {
      url = `${API_URL}api_project_information_exp_status/${id}/${exp_id}/${contracting}/${extension}`;
    }else {
      url = `${API_URL}project-information/${id}/${contracting}`;
    }

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setProjectType(data.project.cons_exp);
        if (
          contracting === "0" &&
          !data.project.alreadyContracted &&
          !(data.project.cons_exp === "exp")
        ) {
          Swal.fire({
            icon: "info",
            title: "Create Contracts First?",
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: "Yes",
            denyButtonText: "No",
          }).then((result) => {
            if (result.isConfirmed) {
              setContracting("1");
              setCreateContracts(true);
            } else if (result.isDenied) {
              setCreateContracts(false);
            }
          });
        }
        if (data.project.cons_exp === "exp") {
          setCreateContracts(false);
        }
        setName(data.project);
        if (data.expert) {
          setData(data.expert);
          if (data.project.utilizationIntensity !== "") {
            setUtilizationIntensity(data.project.utilizationIntensity);
          }
          if (data.project.daysUsed !== "") {
            setDaysUsed(data.project.daysUsed);
          }
          setNoConFound(false);
        } else {
          console.log("No expert interested");
          setNoConFound(true);
          Swal.fire({
            icon: "error",
            title: "Update the status of the consultant to interested",
            showConfirmButton: true,
          });
        }
        if(extension){
          selectData(data.expert[0])
          setSelectedRows([0])
        }

      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const closeProjectHandler = () => {
    if (validateForm()) {
      const ephToken = localStorage.getItem("eph-token");
      const authToken = localStorage.getItem("accesstoken");
      const token = JSON.parse(ephToken).value;
      // const url = `${API_URL}final-project-update`;
      const url = `${API_URL}final-project-update`;
      setFinalUpdateLoading(true);
      const status = "Project Closed (Won)";
      const selectedProjectStatus = status;
      const projectID = parseInt(id);
      let selectedProject;

      const filteredProjects = projects.filter((proj) => proj.id === projectID);
      if (filteredProjects.length > 0) {
        selectedProject = filteredProjects[0];
      } else {
        selectedProject = projectWithFilter.filter(
          (proj) => proj.id === projectID
        )[0];
      }
      // const intExpert = selectedProject.total_interested_expert;
      // const partExpert = selectedProject.total_participated_expert;

      // const modifiedProject = {
      //   ...selectedProject,
      //   status: selectedProjectStatus,
      //   total_interested_expert: intExpert - expertIds.length,
      //   total_participated_expert: partExpert + expertIds.length,
      // };

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({
          expertIds,
          authToken,
          contracting,
          createContracts,
          extension
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          setFinalUpdateLoading(false);
          console.log("here after update", data);
          if (data.status === "success") {
            let swalConfig = {
              icon: "success",
              title:
                contracting === "0"
                  ? "Project Closed successfully."
                  : "Contracts created successfully.",
              showConfirmButton: true,
            };
            if('contractsLocation' in data && data.contractsLocation.length > 0){
              swalConfig.html = `<a href="${data.contractsLocation[0]}" target="_blank">Click here to view the contracts</a>`; // Replace with your URL
            }
            Swal.fire(swalConfig);

            if (userData.enableClosingEmail) {
              setEmailDetails(data.emailDetails);
              if ("followUpEmails" in data) {
                setFollowUpEmailDetails(data.followUpEmails[0]);
                setFollowUpExists(true);
              }
              if (contracting == "0") {
                setComposeEmail(true);
              }
            } else {
              // setProjects(
              //   projects.map((project) =>
              //     project.id === modifiedProject.id ? modifiedProject : project
              //   )
              // );
              if (contracting == "0") {
                if ("followUpEmails" in data) {
                  setFollowUpEmailDetails(data.followUpEmails[0]);
                  setComposeFollowUpEmail(true);
                  setFollowUpExists(true);
                }
              }
            }
            if (contracting === "1") {
              navigateToProjectDetail();
            }
          } else if (data.status === "error") {
            Swal.fire({
              icon: "error",
              title: data.message,
              showConfirmButton: true,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Something went wrong.",
              showConfirmButton: true,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleForeignCurrency = async (currency, rate, profData, party) => {
    // e.preventDefault()
    var currInfo = { chosenCurr: currency, value: rate };
    setGettingExRates(true);
    if (party === "consultant") {
      // await setconsulForeignValue(currInfo)
      const result = await callConsulAPI(currInfo);
      console.log("received", result["data"]);
      if (result["status"] === "success") {
        setGettingExRates(false);

        return JSON.parse(result["data"]);
      } else {
        setGettingExRates(false);

        Swal.fire({
          icon: "error",
          title:
            "Something went wrong while making the currency conversion. Please try again.",
          showConfirmButton: true,
        });
      }
    } else {
      const result = await callConsulAPI(currInfo);
      if (result["status"] === "success") {
        setGettingExRates(false);

        return JSON.parse(result["data"]);
      } else {
        setGettingExRates(false);

        Swal.fire({
          icon: "error",
          title:
            "Something went wrong while making the currency conversion. Please try again.",
          showConfirmButton: true,
        });
      }
    }
  };

  const handleSkipAndClose = () => {
    setFinalUpdateLoading(true);

    const status = "Project Closed (Won)";
    const projectData = {
      selectedProjectStatus: status,
      projectID: id,
    };
    const selectedProjectStatus = status;
    const projectID = parseInt(id);
    let selectedProject;

    const filteredProjects = projects.filter((proj) => proj.id === projectID);
    if (filteredProjects.length > 0) {
      selectedProject = filteredProjects[0];
    } else {
      selectedProject = projectWithFilter.filter(
        (proj) => proj.id === projectID
      )[0];
    }
    const modifiedProject = {
      ...selectedProject,
      status: selectedProjectStatus,
    };

    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;

    fetch(`${API_URL}update-project-status`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(projectData),
    })
      .then((res) => res.json())
      .then((data) => {
        setFinalUpdateLoading(false);
        if (data.status === "success") {
          setProjects(
            projects.map((project) =>
              project.id === modifiedProject.id ? modifiedProject : project
            )
          );
          navigateToProjectDetail();
        } else {
          Swal.fire({
            icon: "error",
            title: "Something went wrong.",
            showConfirmButton: true,
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Database connection error!",
          text: "Please logout and try again.",
          confirmButtonText: "OK",
        });
        console.log(err);
      });
  };

  const calculateSuggestedConRates = async (profData, fromCall = false) => {
    var perMinPayCon = 0;
    var callPayCon = 0;
    var rates = fromCall
      ? consultantRate
      : profData["currencyCon"] !== "EUR"
      ? profData["forconsuleRate"]
      : profData["consultantRate"];
    if (profData["currencyCon"] !== "EUR" && profData["currencyCon"]) {
      if (parseFloat(callDuration) <= 60) {
        perMinPayCon = parseFloat(rates) / 60;
        callPayCon = perMinPayCon * parseFloat(callDuration);
        profData["forconsuleRate"] = callPayCon.toFixed(2);
        profData["suggestedConPay"] = callPayCon.toFixed(2);
        setSuggestedConPay(callPayCon.toFixed(2));
        const info = await handleForeignCurrency(
          profData["currencyCon"],
          callPayCon.toFixed(2),
          profData,
          "consultant"
        );
        profData["consultantRate"] = info.value;
        const resInfo =
          "Exchange rate: " +
          info.rate +
          " as of " +
          info.date +
          ", Value in Euros: " +
          info.value;
        profData["forConsulInfo"] = resInfo;
        const idName = "consulEuroInfo" + profData["id"];
        const elem = document.getElementById(idName);
        if (elem) {
          elem.textContent = resInfo;
        }
      } else {
        callPayCon = rates;
        profData["suggestedConPay"] = rates;
        setSuggestedConPay(rates);
        const info = await handleForeignCurrency(
          profData["currencyCon"],
          rates,
          profData,
          "consultant"
        );
        profData["consultantRate"] = info.value;
        const resInfo =
          "Exchange rate: " +
          info.rate +
          " as of " +
          info.date +
          ", Value in Euros: " +
          info.value;
        profData["forConsulInfo"] = resInfo;
        const idName = "consulEuroInfo" + profData["id"];
        const elem = document.getElementById(idName);
        if (elem) {
          elem.textContent = resInfo;
        }
      }
    } else {
      if (parseFloat(callDuration) <= 60) {
        perMinPayCon = parseFloat(rates) / 60;
        callPayCon = perMinPayCon * parseFloat(callDuration);
        profData["consultantRate"] = callPayCon.toFixed(2);
        profData["suggestedConPay"] = callPayCon.toFixed(2);
        setSuggestedConPay(callPayCon.toFixed(2));
      } else {
        profData["suggestedConPay"] = rates;
        setSuggestedConPay(rates);
      }
    }
  };

  const calculateSuggestedEPHRates = async (profData, fromCall = false) => {
    var perMinPayEPH = 0;
    var callPayEPH = 0;
    var rates = fromCall
      ? ephRate
      : profData["currencyEPH"] !== "EUR"
      ? profData["forephRate"]
      : profData["ephEuroRate"];

    if (profData["currencyEPH"] !== "EUR" && profData["currencyEPH"]) {
      if (parseFloat(callDuration) <= 60) {
        callPayEPH = rates;
        profData["suggestedEPHPay"] = rates;
        setSuggestedEPHPay(rates);
        const info = await handleForeignCurrency(
          profData["currencyEPH"],
          rates,
          profData,
          "EPH"
        );
        profData["ephEuroRate"] = info.value;
        const resInfo =
          "Exchange rate: " +
          info.rate +
          " as of " +
          info.date +
          ", Value in Euros: " +
          info.value;
        profData["forEPHInfo"] = resInfo;
        const idName = "ephEuroInfo" + profData["id"];
        const elem = document.getElementById(idName);
        if (elem) {
          elem.textContent = resInfo;
        }
      } else {
        perMinPayEPH = parseFloat(rates) / 60;
        callPayEPH = perMinPayEPH * parseFloat(callDuration);
        profData["forephRate"] = callPayEPH.toFixed(2);
        profData["suggestedEPHPay"] = callPayEPH.toFixed(2);
        setSuggestedEPHPay(callPayEPH.toFixed(2));
        const info = await handleForeignCurrency(
          profData["currencyEPH"],
          callPayEPH.toFixed(2),
          profData,
          "EPH"
        );
        profData["ephEuroRate"] = info.value;
        const resInfo =
          "Exchange rate: " +
          info.rate +
          " as of " +
          info.date +
          ", Value in Euros: " +
          info.value;
        profData["forEPHInfo"] = resInfo;
        const idName = "ephEuroInfo" + profData["id"];
        const elem = document.getElementById(idName);
        if (elem) {
          elem.textContent = resInfo;
        }
      }
    } else {
      if (parseFloat(callDuration) <= 60) {
        profData["suggestedEPHPay"] = rates;
        setSuggestedEPHPay(rates);
      } else {
        perMinPayEPH = parseFloat(rates) / 60;
        callPayEPH = perMinPayEPH * parseFloat(callDuration);
        profData["ephEuroRate"] = callPayEPH.toFixed(2);
        profData["suggestedEPHPay"] = callPayEPH.toFixed(2);
        setSuggestedEPHPay(callPayEPH.toFixed(2));
      }
    }
  };

  const renderTextBoxes = () => {
    return expertIds.map((profData, index) => (
      <div
        key={profData["id"]}
        className="container-div"
        id={"info" + profData["id"]}
      >
        <fieldset>
          <div className="prj-inf-details-row">
            <div className="form-row">
              <div className="col-2">
                <label className="fieldlabels" style={{ fontWeight: "bold" }}>
                  Details for:
                </label>
              </div>
              <div className="col-4">
                <span className="expName">{profData.name}</span>
              </div>
            </div>
            {projectType === "exp" ? (
              <>
                <div className="form-row prjIn-date-field">
                  <div className="col-2">
                    <label
                      className="fieldlabels"
                      style={{ fontWeight: "bold" }}
                    >
                      Call Date:
                    </label>
                  </div>
                  <div className="col-4">
                    <input
                      type="date"
                      value={profData.startDate ? profData.startDate : ""}
                      onChange={(e) => {
                        setStartDate(e.target.value);
                        profData["startDate"] = e.target.value;
                        setEndDate(e.target.value);
                        profData["endDate"] = e.target.value;
                      }}
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="form-row prjIn-date-field">
                  <div className="col-2">
                    <label
                      className="fieldlabels"
                      style={{ fontWeight: "bold" }}
                    >
                      Start Date:
                    </label>
                  </div>
                  <div className="col-4">
                    <input
                      type="date"
                      value={profData.startDate ? profData.startDate : ""}
                      onChange={(e) => {
                        setStartDate(e.target.value);
                        profData["startDate"] = e.target.value;
                      }}
                    />
                  </div>
                  <div className="col-2">
                    <label
                      className="fieldlabels"
                      style={{ fontWeight: "bold" }}
                    >
                      End Date:
                    </label>
                  </div>
                  <div className="col-4">
                    <input
                      type="date"
                      value={profData.endDate ? profData.endDate : ""}
                      onChange={(e) => {
                        setEndDate(e.target.value);
                        profData["endDate"] = e.target.value;
                        const daysArray = eachDayOfInterval({
                          start: parseISO(profData["startDate"]),
                          end: parseISO(e.target.value)
                        });
                        if(profData["utilizationIntensity"] !== ""){
                          // profData["utilizationIntensity"] = utilizationIntensity;
                        } else {
                          profData["utilizationIntensity"] = 100;
                          setUtilizationIntensity(100);
                        }
                        const workingDays = daysArray.filter(day => !isWeekend(day));
                        profData['totalWorkingDays'] = workingDays.length;
                        const calcDays = (100 / 100) * workingDays.length;
                        setDaysUsed(calcDays.toFixed(1));
                        profData["daysUsed"] = calcDays.toFixed(1);
                        profData["projectID"] = id;
                      }}
                    />
                  </div>
                </div>
              </>
            )}
            <div className="form-row prjIn-select-div">
              <div className="col-2">
                <label className="fieldlabels" style={{ fontWeight: "bold" }}>
                  Consultant {projectType === "exp" ? "Hourly" : ""} Rate:
                </label>
              </div>
              <div className="col-4">
                <select
                  disabled={disableConCurrency}
                  className="form-control"
                  defaultValue={
                    profData["currencyCon"] ? profData["currencyCon"] : ""
                  }
                  onChange={(e) => {
                    profData["currencyCon"] = e.target.value;
                    setCurrencyCon(e.target.value);
                  }}
                >
                  <option value="EUR">EUR</option>
                  <option value="USD">USD</option>
                  <option value="GBP">GBP</option>
                  <option value="CHF">CHF</option>
                  <option value="AUD">AUD</option>
                  <option value="AED">AED</option>
                  <option value="INR">INR</option>
                </select>
                <input
                  // type="number"
                  disabled={disableConRate}
                  defaultValue={
                    profData["currencyCon"]
                      ? profData["currencyCon"] === "EUR"
                        ? profData["consultantRate"]
                        : profData["forconsuleRate"]
                      : ""
                  }
                  onBlur={async (e) => {
                    console.log(profData["currencyCon"]);
                    if (
                      profData["currencyCon"] !== "EUR" &&
                      profData["currencyCon"]
                    ) {
                      profData["forconsuleRate"] = e.target.value;
                      setConsultantRate(e.target.value);
                      const info = await handleForeignCurrency(
                        profData["currencyCon"],
                        profData["forconsuleRate"],
                        profData,
                        "consultant"
                      );
                      profData["consultantRate"] = info.value;
                      const resInfo =
                        "Exchange rate: " +
                        info.rate +
                        " as of " +
                        info.date +
                        ", Value in Euros: " +
                        info.value;
                      profData["forConsulInfo"] = resInfo;
                      const idName = "consulEuroInfo" + profData["id"];
                      const elem = document.getElementById(idName);
                      if (elem) {
                        elem.textContent = resInfo;
                      }
                    } else {
                      profData["currencyCon"] = "EUR";
                      profData["forconsuleRate"] = "";
                      profData["consultantRate"] = e.target.value;
                      profData["forConsulInfo"] = "";
                      setConsultantRate(e.target.value);
                    }
                    if (profData["callDuration"]) {
                      calculateSuggestedConRates(profData);
                    }
                  }}
                />
              </div>
              <div className="col-2">
                <label className="fieldlabels" style={{ fontWeight: "bold" }}>
                  EPH {projectType === "exp" ? "Hourly" : ""} Rate:
                </label>
              </div>
              <div className="col-4">
                <select
                  disabled={disableEPHCurrency}
                  className="form-control"
                  defaultValue={
                    profData["currencyEPH"] ? profData["currencyEPH"] : ""
                  }
                  onChange={(e) => {
                    profData["currencyEPH"] = e.target.value;
                    setCurrencyEPH(e.target.value);
                  }}
                >
                  <option value="EUR">EUR</option>
                  <option value="USD">USD</option>
                  <option value="GBP">GBP</option>
                  <option value="CHF">CHF</option>
                  <option value="AUD">AUD</option>
                  <option value="AED">AED</option>
                  <option value="INR">INR</option>
                </select>
                <input
                  // type="number"
                  disabled={disableEPHRate}
                  defaultValue={
                    profData["currencyEPH"]
                      ? profData["currencyEPH"] === "EUR"
                        ? profData["ephEuroRate"]
                        : profData["forephRate"]
                      : ""
                  }
                  onBlur={async (e) => {
                    if (
                      profData["currencyEPH"] !== "EUR" &&
                      profData["currencyEPH"]
                    ) {
                      profData["forephRate"] = e.target.value;
                      setEphRate(e.target.value);
                      const info = await handleForeignCurrency(
                        profData["currencyEPH"],
                        profData["forephRate"],
                        profData,
                        "EPH"
                      );
                      profData["ephEuroRate"] = info.value;
                      const resInfo =
                        "Exchange rate: " +
                        info.rate +
                        " as of " +
                        info.date +
                        ", Value in Euros: " +
                        info.value;
                      profData["forEPHInfo"] = resInfo;
                      const idName = "ephEuroInfo" + profData["id"];
                      const elem = document.getElementById(idName);
                      if (elem) {
                        elem.textContent = resInfo;
                      }
                    } else {
                      profData["ephEuroRate"] = e.target.value;
                      profData["currencyEPH"] = "EUR";
                      profData["forephRate"] = "";
                      profData["forEPHInfo"] = "";
                      setEphRate(e.target.value);
                    }
                    if (profData["callDuration"]) {
                      calculateSuggestedEPHRates(profData);
                    }
                  }}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="col-6">
                <span className="hint" id={"consulEuroInfo" + profData["id"]}>
                  {profData["forConsulInfo"] ? profData["forConsulInfo"] : ""}
                </span>
                <span
                  className="hint"
                  id="consulCurrEurInfo_{{loop.index}}"
                ></span>
              </div>
              <div className="col-6">
                <span className="hint" id={"ephEuroInfo" + profData["id"]}>
                  {profData["currency"] ? profData["forEPHInfo"] : ""}
                </span>
                <span
                  className="hint"
                  id="ephCurrEurInfo_{{loop.index}}"
                ></span>
              </div>
            </div>
            {projectType === "exp" ? (
              <>
                <div className="form-row">
                  <div className="col-2">
                    <label
                      className="fieldlabels"
                      style={{ fontWeight: "bold" }}
                    >
                      Call Duration {"("}in min{")"}:{" "}
                    </label>
                  </div>
                  <div className="col-4">
                    <input
                      type="number"
                      value={
                        profData["callDuration"] ? profData["callDuration"] : ""
                      }
                      onChange={(e) => {
                        profData["callDuration"] = e.target.value;
                        setCallDuration(e.target.value);
                        // setUtilizationIntensity(e.target.value);
                        // profData["projectID"] = id;
                      }}
                      onBlur={async (e) => {
                        calculateSuggestedConRates(profData, true);
                        calculateSuggestedEPHRates(profData, true);
                        if(extension === '1' && projectType === 'exp'){
                          profData["utilizationIntensity"] = 100;
                        }
                        // setDisableConRate(true)
                        // setDisableEPHRate(true)
                        // setDisableConCurrency(true)
                        // setDisableEPHCurrency(true)
                      }}
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="form-row">
                  <div className="col-2">
                    <label
                      className="fieldlabels"
                      style={{ fontWeight: "bold" }}
                    >
                      Utilization Intensity %:
                    </label>
                  </div>
                  <div className="col-4">
                    <input
                      type="percentage"
                      value={utilizationIntensity ? utilizationIntensity : ""}
                      onChange={(e) => {
                        profData["utilizationIntensity"] = e.target.value;
                        setUtilizationIntensity(e.target.value);
                        const calcDays = (e.target.value / 100) * profData['totalWorkingDays'];
                        setDaysUsed(calcDays.toFixed(1));
                        profData["daysUsed"] = calcDays.toFixed(1);
                        profData["projectID"] = id;
                      }}
                    />
                  </div>
                  <div className="col-2">
                    <label
                      className="fieldlabels"
                      style={{ fontWeight: "bold" }}
                    >
                      Total Days:
                    </label>
                  </div>
                  <div className="col-4">
                    <input
                      // type="percentage"
                      value={daysUsed ? daysUsed : ""}
                      onChange={(e) => {
                        profData["daysUsed"] = e.target.value;
                        setDaysUsed(e.target.value);
                        const calcUtil = (e.target.value / profData['totalWorkingDays']) * 100;
                        setUtilizationIntensity(calcUtil.toFixed(1));
                        profData["utilizationIntensity"] = calcUtil.toFixed(1);
                        // profData["projectID"] = id;
                      }}
                    />
                  </div>
                </div>
              </>
            )}
            {projectType === "exp" ? (
              <div className="form-row prjIn-select-div">
                <div className="col-2">
                  <label className="fieldlabels" style={{ fontWeight: "bold" }}>
                    Suggested Consultant Payment:
                  </label>
                </div>
                <div className="col-4">
                  <select
                    className="form-control"
                    value={currencyCon ? currencyCon : ""}
                    onChange={(e) => {
                      profData["currencyCon"] = e.target.value;
                    }}
                  >
                    <option value="EUR">EUR</option>
                    <option value="USD">USD</option>
                    <option value="GBP">GBP</option>
                    <option value="CHF">CHF</option>
                    <option value="AUD">AUD</option>
                    <option value="AED">AED</option>
                    <option value="INR">INR</option>
                  </select>
                  <input
                    type="number"
                    defaultValue={
                      profData["suggestedConPay"]
                        ? profData["suggestedConPay"]
                        : ""
                    }
                    onBlur={async (e) => {
                      console.log(profData["currencyCon"]);
                      if (
                        profData["currencyCon"] !== "EUR" &&
                        profData["currencyCon"]
                      ) {
                        profData["forconsuleRate"] = e.target.value;
                        const info = await handleForeignCurrency(
                          profData["currencyCon"],
                          profData["forconsuleRate"],
                          profData,
                          "consultant"
                        );
                        profData["consultantRate"] = info.value;
                        const resInfo =
                          "Exchange rate: " +
                          info.rate +
                          " as of " +
                          info.date +
                          ", Value in Euros: " +
                          info.value;
                        profData["forConsulInfo"] = resInfo;
                        const idName = "consulEuroInfo" + profData["id"];
                        const elem = document.getElementById(idName);
                        if (elem) {
                          elem.textContent = resInfo;
                        }
                      } else {
                        profData["currencyCon"] = "EUR";
                        profData["forconsuleRate"] = "";
                        profData["consultantRate"] = e.target.value;
                        profData["forConsulInfo"] = "";
                        setConsultantRate(e.target.value);
                      }
                    }}
                  />
                </div>
                <div className="col-2">
                  <label className="fieldlabels" style={{ fontWeight: "bold" }}>
                    Suggested Client Rate:
                  </label>
                </div>
                <div className="col-4">
                  <select
                    className="form-control"
                    value={currencyEPH ? currencyEPH : ""}
                    onChange={(e) => {
                      profData["currencyEPH"] = e.target.value;
                    }}
                  >
                    <option value="EUR">EUR</option>
                    <option value="USD">USD</option>
                    <option value="GBP">GBP</option>
                    <option value="CHF">CHF</option>
                    <option value="AUD">AUD</option>
                    <option value="AED">AED</option>
                    <option value="INR">INR</option>
                  </select>
                  <input
                    type="number"
                    defaultValue={
                      profData["suggestedEPHPay"]
                        ? profData["suggestedEPHPay"]
                        : ""
                    }
                    onBlur={async (e) => {
                      if (
                        profData["currencyEPH"] !== "EUR" &&
                        profData["currencyEPH"]
                      ) {
                        profData["forephRate"] = e.target.value;
                        const info = await handleForeignCurrency(
                          profData["currencyEPH"],
                          profData["forephRate"],
                          profData,
                          "EPH"
                        );
                        profData["ephEuroRate"] = info.value;
                        const resInfo =
                          "Exchange rate: " +
                          info.rate +
                          " as of " +
                          info.date +
                          ", Value in Euros: " +
                          info.value;
                        profData["forEPHInfo"] = resInfo;
                        const idName = "ephEuroInfo" + profData["id"];
                        const elem = document.getElementById(idName);
                        if (elem) {
                          elem.textContent = resInfo;
                        }
                      } else {
                        profData["ephEuroRate"] = e.target.value;
                        profData["currencyEPH"] = "EUR";
                        profData["forephRate"] = "";
                        profData["forEPHInfo"] = "";
                        setEphRate(e.target.value);
                      }
                    }}
                  />
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </fieldset>
      </div>
    ));
  };

  return (
    <>
      <ProjectTitle project={name} />
      <div className="container-div">
        {!noConFound && (
          <Table
            mockData={data}
            selectData={selectData}
            unselectData={unselectData}
            projectID={id}
            preselectedRows={selectedRows}
          />
        )}
        {noConFound && (
          <div className="topCon-table-row">
            <div className="topCon-top-div" style={{ height: "45px" }}>
              <h5 style={{ textAlign: "center", paddingTop: "10px" }}>
                No interested consultants
              </h5>
            </div>
            <div className="topCon-row-bottom"></div>
          </div>
        )}
      </div>
      <br></br>
      <div className="details-container">{renderTextBoxes()}</div>
      <br></br>
      <div className="container-div">
        <div className="prj-inf-btn-div">
          <button
            type="button"
            className="btn btn-light"
            onClick={handleSkipAndClose}
          >
            Skip and Close
          </button>
          <button
            type="button"
            className="btn base-btn"
            onClick={closeProjectHandler}
          >
            Submit
          </button>
          <button
            type="button"
            className="btn btn-light"
            onClick={navigateToProjectOverview}
          >
            Cancel
          </button>
        </div>
      </div>
      {FinalUpdateLoading && (
        <div className="updateToZoho-popup-wrapper">
          <div className="tab-pane fade show updateToZoho-div">
            <center>
              <p style={{ fontSize: "18px" }}>
                {contracting === "0"
                  ? "Finalizing Project..."
                  : "Creating Contracts..."}
              </p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}

      {gettingExRates && (
        <div className="updateToZoho-popup-wrapper">
          <div className="tab-pane fade show updateToZoho-div">
            <center>
              <p style={{ fontSize: "18px" }}>Fetching Exchange Rate...</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
      {/* <div style={{ maxWidth: '100%' }}>
            <MaterialTable
              columns={[
                { title: 'Adı', field: 'name' },
                { title: 'Soyadı', field: 'surname' },
                { title: 'Doğum Yılı', field: 'birthYear', type: 'numeric' },
                { title: 'Doğum Yeri', field: 'birthCity', lookup: { 34: 'İstanbul', 63: 'Şanlıurfa' } }
              ]}
              data={[{ name: 'Mehmet', surname: 'Baran', birthYear: 1987, birthCity: 63 }]}
              title="Demo Title"
            />
          </div> */}
      {composeEmail && (
        <EmailComposer
          emailDetails={emailDetails}
          onClose={() => {
            const selectedProjectStatus = "Project Closed (Won)";
            const projectID = parseInt(id);
            let selectedProject;

            const filteredProjects = projects.filter(
              (proj) => proj.id === projectID
            );
            if (filteredProjects.length > 0) {
              selectedProject = filteredProjects[0];
            } else {
              selectedProject = projectWithFilter.filter(
                (proj) => proj.id === projectID
              )[0];
            }
            // const intExpert = selectedProject.total_interested_expert;
            // const partExpert = selectedProject.total_participated_expert;

            // const modifiedProject = {
            //   ...selectedProject,
            //   status: selectedProjectStatus,
            //   total_interested_expert: intExpert - expertIds.length,
            //   total_participated_expert: partExpert + expertIds.length,
            // };
            // setProjects(
            //   projects.map((project) =>
            //     project.id === modifiedProject.id ? modifiedProject : project
            //   )
            // );
            setComposeEmail(false);
            if (followUpExists) {
              setComposeFollowUpEmail(true);
            } else {
              navigateToProjectDetail();
            }
          }}
          onSend={(modifiedEmail) => {
            setLoadingPopup(true);

            // Handle the sending logic here, e.g., make an API call to send the modified email
            console.log("Sending modified email:", modifiedEmail);
            // Close the EmailComposer component
            const authToken = localStorage.getItem("accesstoken");
            const tokenObj = localStorage.getItem("eph-token");
            const url = `${API_URL}send-email-through-graphapi`;

            // const url = "https://85.215.43.43:3001/api/send-email-through-graphapi";
            fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "x-access-token": authToken,
                tokenObj: JSON.parse(tokenObj).value,
              },
              body: JSON.stringify(modifiedEmail),
            })
              .then((res) => res.json())
              .then((data) => {
                setLoadingPopup(false);
                const selectedProjectStatus = "Project Closed (Won)";
                const projectID = parseInt(id);
                let selectedProject;

                const filteredProjects = projects.filter(
                  (proj) => proj.id === projectID
                );
                if (filteredProjects.length > 0) {
                  selectedProject = filteredProjects[0];
                } else {
                  selectedProject = projectWithFilter.filter(
                    (proj) => proj.id === projectID
                  )[0];
                }
                // const intExpert = selectedProject.total_interested_expert;
                // const partExpert = selectedProject.total_participated_expert;

                // const modifiedProject = {
                //   ...selectedProject,
                //   status: selectedProjectStatus,
                //   total_interested_expert: intExpert - expertIds.length,
                //   total_participated_expert: partExpert + expertIds.length,
                // };
                // setProjects(
                //   projects.map((project) =>
                //     project.id === modifiedProject.id
                //       ? modifiedProject
                //       : project
                //   )
                // );

                if (data.status === "success") {
                  setComposeEmail(false);
                  if (followUpExists) {
                    setComposeFollowUpEmail(true);
                  } else {
                    navigateToProjectDetail();
                  }
                  Swal.fire({
                    icon: "success",
                    title: "Email sent successfully",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                } else if (data.status === "error") {
                  Swal.fire({
                    icon: "success",
                    title: "Error",
                    text: `${data.message}`,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                }

                // setProjectInfo(data.projectInfo);
              })
              .catch((err) => console.log(err));
          }}
        />
      )}
      {composeFollowUpEmail && (
        <EmailComposer
          emailDetails={followUpEmailDetails}
          onClose={() => {
            setComposeFollowUpEmail(false);
            navigateToProjectDetail();
          }}
          onSend={(modifiedEmail) => {
            setLoadingPopup(true);

            // Handle the sending logic here, e.g., make an API call to send the modified email
            console.log("Sending modified email:", modifiedEmail);
            // Close the EmailComposer component
            const authToken = localStorage.getItem("accesstoken");
            const tokenObj = localStorage.getItem("eph-token");
            const url = `${API_URL}send-email-through-graphapi`;

            fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "x-access-token": authToken,
                tokenObj: JSON.parse(tokenObj).value,
              },
              body: JSON.stringify(modifiedEmail),
            })
              .then((res) => res.json())
              .then((data) => {
                setLoadingPopup(false);

                if (data.status === "success") {
                  setComposeFollowUpEmail(false);
                  navigateToProjectDetail();
                  Swal.fire({
                    icon: "success",
                    title: "Email sent successfully",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                } else if (data.status === "error") {
                  Swal.fire({
                    icon: "success",
                    title: "Error",
                    text: `${data.message}`,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                }

                // setProjectInfo(data.projectInfo);
              })
              .catch((err) => console.log(err));
          }}
        />
      )}
      {loadingPopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <center>
              <p style={{ fontSize: "18px" }}>Please wait . . .</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
